<template>
    <div id="oma-player" v-if="oma">
        <span id="popup" v-show="state == oma.player.STATES.LOADING ||state ==  oma.player.STATES.ERROR">
            <span v-show="state == oma.player.STATES.LOADING">
                Chargement (peut prendre plusieurs minutes sur iphone ou mac)…
            </span>
            <span v-show="state ==  oma.player.STATES.ERROR">
                Erreur audio :'(<br />
                <span v-if="oma.player.errorMsg">
                {{oma.player.errorMsg}}<br />
                </span>
                 Réessayez ou contactez nous.
            </span>
        </span>

        <div class="flexcontainer">
            <div id="images">
                <contextual-image class="oma-player-image" :channel="10" :oma="oma"></contextual-image>
            </div>
            <div id="titleliste">
                <p>
                    <span class="typetext" v-if="oma.player.TYPES.isDirect">Direct</span>
                    <span class="typetext" v-else-if="oma.player.TYPES.isReplay">Replay</span>
                    <span class="typetext" v-else-if="oma.player.TYPES.isPodcast">Podcast</span>
                    <a @click="oma.player.playDirect()" class="backtodirect" v-if="oma.player.TYPES.isReplay || oma.player.TYPES.isPodcast">Retour au direct</a>
                </p>
                <template v-if="oma.player.TYPES.isPodcast">
                    <p><a onclick="return internalNavigation(event)" :href="'/episode/' + oma.player.currentFile + '.html'">{{ oma.player._current_stream.prettyName}}</a></p>
                    <p v-if="oma.player._current_stream.serieName">Dans <a onclick="return internalNavigation(event)" :href="'/serie/' + oma.player._current_stream.serieName + '.html'">{{ oma.player._current_stream.serieTitre}}</a></p>
                </template>
                <contextual-titles v-show="!oma.player.TYPES.isPodcast" :oma="oma" channel="0"></contextual-titles>
            </div>
            <div id="controls">
                <oma-controls class="oma-player-controls" :oma="oma" :show-time-controls="oma.omaWebsocket!==null" :paused="state != oma.player.STATES.PLAYING" @playpause="oma.player.play_pause()" @forward="oma.player.forward($event)" :showFuture="oma.player.TYPES.isReplay || oma.player.TYPES.isPodcast" :showPast="true"></oma-controls>
                <oma-volume class="oma-volume" :volume="oma.player.volume*100" :mute="oma.player.muted" @volume="oma.player.volume=($event/100.0)" @mute="oma.player.muted=true" @unmute="oma.player.muted=false"></oma-volume>
                <progress-bar v-if="oma.player.TYPES.isPodcast" :current="oma.player.currentTime" :max="oma.player._current_stream.player.duration" @progress="oma.player._current_stream.player.currentTime=$event" ></progress-bar>
                <div v-if="oma.player.TYPES.isReplay">Replay du {{ prettyTime }}</div>
            </div>

        </div>
    </div>
</template>

<script>
import OmaControls from './OmaControls.vue'
import OmaVolume from './OmaVolume.vue'
import ContextualImage from './ContextualImage.vue'
import {omaInitWrapper} from '../frontlib.js'
import ContextualTitles from './ContextualTitles'
import ProgressBar from './ProgressBar'

export default {
    props: {
        handsetdate: {type: Boolean, default: true},
    },
    data: () => { return {
        oma: null,
        playText: 'Écoutez ou réécoutez',
        mute: false,
        paused: true,
        state: '',
        type: '',
        volume: 100,
        replayDate: null,
        replayTime: null,
    }},
    computed: {
        prettyTime: function () {
            return (new Date(this.oma.player.currentTime *1000)).toLocaleString()
        },
    },
    created: function () {
        omaInitWrapper(window.OMA_CONFIG)
        .then(oma => {
            this.oma = oma

            /* In vue3 reactivity doesn work anymore on oma sub objects? So we set up callbacks */
            this.oma.player.onpaused = (value => {
                this.paused = value
            })
            this.oma.player.onstate = (value => {
                this.state = value
            })
            this.oma.player.ontype = (value => {
                this.type = value
            })

            this.oma.player.reinit();
            window.OMA_DATA = this.oma

            var hash = window.location.hash.slice(1)
            const ts = parseInt(hash)
            if (hash == 'direct') {
                this.oma.player.playDirect(true)
            } else if (hash.includes('-')) {
                let tab = hash.split(':')
                this.oma.player.playPodcast(tab[0], null, null, null, true, tab.length>1 ? tab[1] : 0)
            } else if (ts) {
                this.oma.player.setDate(ts, null, true)
            }

            window.advancedSite = true;
            window.enableAdvancedSite();

            this.state = this.oma.player.state
        })
    },
    methods: {
        replay: function () {
            this.oma.player.set_date_human(this.replayDate, this.replayTime)
        }
    },
    components: {
        OmaControls,
        OmaVolume,
        ProgressBar,
        ContextualTitles,
        ContextualImage,
    },
}
</script>

<style scoped>

#oma-player {
    position: relative;
    height:5em;
    height:4vh;
    min-height:110px;
    border-top: 1px solid black;
    color: #ddd;
    background-color: #373737;
    width: 100%;
}

a {
    text-decoration: underline;
    color: #ddd;
}
.oma-player-image {
    height:100%;
}

#popup {
    z-index:999;
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,.9);
}

.rotation {
    animation: rotation 1s;
    animation-timing-function: steps(8);
    animation-iteration-count: infinite;
    font-size:3em;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.flexcontainer {
    display: flex;
    flex-wrap: nowrap;
    height: 100%;
}
.flexcontainer > * {
    flex-shrink: 0;
}

.flexcontainer > div:not(:last-child) {
    /*border-right: 1px solid black;*/
    margin-right: 1%;
}

.flexcontainer > div {
    overflow: hidden;
    margin-top: 5px;
}

#titleliste {
    width: calc(100% - 237px - 112px);
    margin: 0;
    padding-top:3px;
    height: 100px;
}
#controls {
    width:220px;
    padding-left: 5px;
    padding-right: 10px;
}
#images {
    height: 100px;
    width: 100px;
    margin: 5px;
}
#titleliste > p:first-child{
    text-align: center;
}
#titleliste > p{
    margin: 0;
}
.typetext{
    font-weight: bold;
    border: 1px solid;
    border-radius: 5px;
    padding: 0 6px;
}
.backtodirect {
    font-size: 0.8em;
    margin-left: 5px;
}
.oma-volume {
    width: 100%;
}

@media only screen and (max-device-width: 600px) {

    .flexcontainer {
        flex-wrap: wrap;
    }
    #oma-player {
        height:10em;
        height:400px;
        font-size: 2em;
    }

    .oma-player-controls {
        /*height: 200px;*/
    }
    #images {
        height: 200px;
        width: 200px;
        margin: 10px;
    }
    #titleliste {
        height: 200px;
        width: calc( 100% - 224px);
        margin: 0;
    }
    #controls {
        width:440px;
    }
}

</style>
